module.exports = __webpack_public_path__ + "static/img/OregonOffshore-RA.1b160cd.png";